<template>
  <div v-if="isLayerShow() && observatories.length > 0">
    <template v-for="ob in observatories">
      <l-marker
        :key="ob.osid"
        :lat-lng="[ob.lat, ob.lng]"
        class="wind-marker"
      >
        <l-icon
          v-if="!ob.status.speed || ob.status.direction === 0"
          :icon-size="[12, 12]"
          :icon-anchor="[6, 6]"
        >
          <v-icon class="outlined" color="#b9ebfa" x-small>
            mdi-circle
          </v-icon>
        </l-icon>
        <l-icon
            v-else
            :icon-size="[30, 30]"
            :icon-anchor="[15, 15]"
        >
          <v-icon
              :style="
                `transform: rotate(${(360 / 16) *
                  ob.status.direction -
                  180}deg)`
              "
              :color="getWindColor(ob.status.speed)"
              class="outlined"
          >
            mdi-navigation
          </v-icon>
        </l-icon>
      </l-marker>
    </template>
  </div>
</template>
<script>
import { LIcon, LMarker } from "vue2-leaflet";
import { OBSERVATORY } from "@/enums/Type";
export default {
  name: "ObservatoryWindLayer",
  components: {
    LIcon,
    LMarker,
  },
  computed: {
    baseDate() {
      return this.$store.getters.baseDate;
    },
    riskSubControl() {
      return this.$store.getters.riskSubControl;
    },
    observatories() {
      const observatories = this.$store.getters.observatories;
      return observatories.filter(obs => {
        return obs.type === OBSERVATORY.WIND.code
      })
    },
  },
  methods: {
    getWindColor(speed) {
      const value = speed;
      const colors = [
        { color: "#b40068", value: 25 },
        { color: "#f12705", value: 20 },
        { color: "#f49904", value: 15 },
        { color: "#f9f503", value: 10 },
        { color: "#3e42ff", value: 5 },
        { color: "#b9ebfa", value: 0 }
      ];

      let current;
      for (const color of colors) {
        if (color.value <= value) {
          current = color.color;
          break;
        }
      }
      return current;
    },
    onClickMarker(ob) {
      this.$store.commit("SET_OBSERVATORY_WIND_SELECTED_OBSERVATORY", ob);
      this.$store.commit("SET_MAP_DETAIL", {
        isShowing: true,
        title: "風観測所 - " + ob.name,
        contents: "wind-detail"
      });
    },
    isLayerShow() {
      return this.riskSubControl.observatory.includes(OBSERVATORY.WIND.code);
    }
  }
};
</script>
<style>
.v-icon.outlined {
  color: white;
  text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000,
    1px 1px 0 #000;
}
</style>
